<mat-drawer-container hasBackdrop="false">
  <mat-drawer #drawer mode="over" [opened]="drawer.opened || mobileMode" disableClose="mobileMode">
    <div fxHide fxShow.gt-sm class="title">
      <button mat-icon-button (click)="drawer.toggle()">
        <mat-icon class="icon-menu"></mat-icon>
      </button>
      <div class="logoImg">
        <img src="./assets/images/genesis-logo.svg" alt="" />
      </div>
    </div>
    <mat-nav-list>
      <mat-list-item class="parent" routerLink="./demographics" routerLinkActive="active" (click)="drawerClose()">
        <mat-icon matListItemIcon [ngClass]="{'icon-demographics': true, 'icon-active': router.url.startsWith('/demographics')}"
          routerLinkActive="active"></mat-icon>
        <span class="item-text" routerLinkActive="active">Demographics</span>
      </mat-list-item>
      <mat-list-item class="parent" routerLink="./schedule" routerLinkActive="active" (click)="drawerClose()">
        <mat-icon matListItemIcon [ngClass]="{'icon-schedule': true, 'icon-active': router.url.startsWith('/schedule')}"
          routerLinkActive="active"></mat-icon>
        <span class="item-text" routerLinkActive="active">Schedule</span>
      </mat-list-item>
      <mat-list-item class="parent new-messages" routerLink="./messages" routerLinkActive="active"
        (click)="drawerClose()">
        <mat-icon matListItemIcon [ngClass]="{'icon-messages': true, 'icon-active': router.url.startsWith('/messages')}"
          routerLinkActive="active"></mat-icon>
        <span class="item-text" routerLinkActive="active">Messages</span>
      </mat-list-item>
      <mat-list-item class="parent" routerLink="./pto-request" routerLinkActive="active" (click)="drawerClose()">
        <mat-icon matListItemIcon [ngClass]="{'icon-pto': true, 'icon-active': router.url.startsWith('/pto-request')}"
          routerLinkActive="active"></mat-icon>
        <span class="item-text" routerLinkActive="active">PTO Request</span>
      </mat-list-item>
      <mat-list-item class="parent" routerLink="./shift-bid" routerLinkActive="active" (click)="drawerClose()">
        <mat-icon matListItemIcon [ngClass]="{'icon-shift-bid': true, 'icon-active': router.url.startsWith('/shift-bid')}"
          routerLinkActive="active"></mat-icon>
        <span class="item-text" routerLinkActive="active">Shift Bidding</span>
      </mat-list-item>
      <mat-list-item class="parent" *ngIf="showTimeAllocation" routerLink="./time-allocation" routerLinkActive="active" (click)="drawerClose()">
        <mat-icon matListItemIcon [ngClass]="{'icon-time-allocation': true, 'icon-active': router.url.startsWith('/time-allocation')}"
          routerLinkActive="active"></mat-icon>
        <span class="item-text" routerLinkActive="active">Time Allocation</span>
      </mat-list-item>
      <mat-list-item matListItemIcon class="parent" (click)="logout()" fxHide fxShow.gt-sm>
        <mat-icon class="icon-sign-out" routerLinkActive="active"></mat-icon>
        <span class="item-text" routerLinkActive="active">Logout</span>
      </mat-list-item>
    </mat-nav-list>
  </mat-drawer>

  <mat-drawer-content fxFlex fxLayout="column">
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
